import React from 'react';
import tw from 'tailwind-styled-components';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { HomeCategoriesLoading } from '../components/SkeletonLoading/HomeCategoriesLoading';
import { useNavigate } from 'react-router-dom';

const Categories = ({ categoriesData, bgImage }) => {
    const navigate = useNavigate();

    const handleCategoryClick = (category) => {
    const title = encodeURIComponent(category.name);
    navigate(`/products/all-products?category_id=${category.id}&title=${title}`);
};

    const handleDiscoverMore = () => {
        navigate('/categories');
    };

    const sectionTitles = [
        "Daily & Lifestyle Essentials",
        "Home, Office & Kids",
        "Culture & Travel",
        // "Finds for Home"
    ];

    const buttonTexts = [
        "Discover more",
        "Discover more",
        // "Discover more",
        "Discover more"
    ];

    const processCategories = (data) => {
        if (!data || data.length === 0) return [];
        return data
            .filter(category => category.is_active)
            .sort((a, b) => a.sort_order - b.sort_order);
    };

    const activeCategories = processCategories(categoriesData);

    // Group categories into sections of 4
    const groupCategories = () => {
        const sections = [];
        for (let i = 0; i < 3; i++) {
            const startIndex = i * 4;
            const sectionCategories = activeCategories.slice(startIndex, startIndex + 4);
            sections.push({
                title: sectionTitles[i],
                buttonText: buttonTexts[i],
                categories: sectionCategories
            });
        }
        return sections;
    };

    if (!categoriesData || categoriesData.length === 0) {
        return (<HomeCategoriesLoading />);
    }

    const sections = groupCategories();

    return (
        <CategoriesContainer style={{ backgroundImage: `url(${bgImage})` }}>
            <CategoriesWrapper>
                <CategoriesGrid>
                    {sections.map((section, sectionIndex) => (
                        <CategorySection key={sectionIndex}>
                            <SectionTitle>{section.title}</SectionTitle>
                            <CategoryItemsGrid> {/* Categories Grid - 2x2 */}
                                {section.categories.map((category, itemIndex) => (
                                    <CategoryItem key={category.id || itemIndex} onClick={() => handleCategoryClick(category)}
                                    className="cursor-pointer hover:opacity-80 transition-opacity">
                                        <CategoryImageContainer>  {/* Category Image */}
                                            {category.image ? (
                                                <CategoryImage
                                                    src={`${category.image}`}
                                                    alt={category.name}
                                                />
                                            ) : (
                                                <CategoryImagePlaceholder />
                                            )}
                                        </CategoryImageContainer>
                                        {/* Category Name */}
                                        <CategoryName>{category.name}</CategoryName>
                                    </CategoryItem>
                                ))}
                            </CategoryItemsGrid>
                            
                            <button className="text-kuality-blue text-sm" onClick={handleDiscoverMore}>
                                {section.buttonText}
                            </button>
                        </CategorySection>
                    ))}
                </CategoriesGrid>
            </CategoriesWrapper>
        </CategoriesContainer>
    );
};

// Styled Components
const CategoriesContainer = tw.div`bg-gray-50 py-8`;
const CategoriesWrapper = tw.div`mx-auto px-4`;
const CategoriesGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6`;
const CategorySection = tw.div`bg-white rounded-lg p-4`;
const SectionTitle = tw.h2`text-xl font-bold text-gray-900 mb-4`;
const CategoryItemsGrid = tw.div`grid grid-cols-2 gap-3 mb-4`;
const CategoryItem = tw.div`text-center`;
const CategoryImageContainer = tw.div`aspect-square bg-gray-100 rounded mb-2`;
const CategoryImage = tw.img`w-full h-full object-cover rounded`;
const CategoryImagePlaceholder = tw.div`w-full h-full bg-gray-200 rounded`;
const CategoryName = tw.p`text-sm text-gray-800`;

export default Categories;